export default "__VITE_ASSET__BFjCYVy1__"